function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo, useRef } from 'react';
import cn from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { richTextValidation } from 'validators';
import { FullColumn, RichTextEditor, TextButton, Typography, useDevice, useIsInBottomSheet } from 'seagull';
import { AIEdit24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useRichTextVariableIntegration } from "../AgreementStudioPage/TemplateVariables/hooks/useRichTextVariableIntegration";
import { VariableInsertButton } from "../AgreementStudioPage/TemplateVariables/VariableInsertButton/VariableInsertButton";
import { VariablePickerPopover } from "../AgreementStudioPage/TemplateVariables/VariablePickerPopover/VariablePickerPopover";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { connectControllerToRichTextEditor } from "../../utils/react-hook-form.utils";
import styles from "./ServiceDescription.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const GetServiceDescriptionTID = parentTestId => getTestIds(parentTestId);
const ServiceDescription = _ref => {
  let {
    testId,
    hideLabel = false,
    onChange: _onChange = () => {},
    onHelpMeWriteClick,
    disabledHelpMeWrite = false,
    isDrawerOpen = false,
    disabled = false
  } = _ref;
  const {
    SERVICE_DESCRIPTION_AI
  } = useFeatureFlags();
  const {
    isMobileDevice
  } = useDevice();
  const isInBottomSheet = useIsInBottomSheet();
  const hideHelpMeWrite = isInBottomSheet || isMobileDevice;
  const {
    control,
    watch
  } = useFormContext();
  const isBundle = Boolean(watch('bundle'));
  const {
    ServiceDescriptionTestIds
  } = useMemo(() => GetServiceDescriptionTID(testId), [testId]);
  const editorElRef = useRef(null);
  const {
    enabled: variablesEnabled,
    toolbarButtonProps,
    pickerPopoverProps
  } = useRichTextVariableIntegration(editorElRef, {
    disabled
  });
  const isOnlyDisabledHelpMeWrite = !isDrawerOpen && disabledHelpMeWrite;
  const helpMeWriteButton = SERVICE_DESCRIPTION_AI && !!onHelpMeWriteClick && !hideHelpMeWrite ? /*#__PURE__*/_jsx("div", {
    className: styles.helpMeWriteButtonWrapper,
    children: /*#__PURE__*/_jsx(TextButton, {
      tooltip: isOnlyDisabledHelpMeWrite && {
        title: 'Please name this service first',
        placement: 'top'
      },
      prefixIcon: /*#__PURE__*/_jsx("span", {
        className: cn({
          [styles.iconWrapper]: !isDrawerOpen
        }),
        children: /*#__PURE__*/_jsx(AIEdit24, {})
      }),
      underline: "none",
      weight: "normal",
      skin: isDrawerOpen ? 'focusPrimary' : 'primary',
      disabled: isOnlyDisabledHelpMeWrite,
      onClick: onHelpMeWriteClick,
      testId: ServiceDescriptionTestIds.HelpMeWriteButton(),
      children: /*#__PURE__*/_jsx("span", {
        className: cn({
          [styles.textWrapper]: !isDrawerOpen
        }),
        "data-text": "Help me write",
        children: "Help me write"
      })
    })
  }) : null;
  const variableButton = variablesEnabled ? /*#__PURE__*/_jsx(VariableInsertButton, _objectSpread({}, toolbarButtonProps)) : null;
  const toolbarActions = /*#__PURE__*/_jsxs("div", {
    className: styles.toolbarActionsRow,
    children: [variableButton, variableButton && helpMeWriteButton && /*#__PURE__*/_jsx("div", {
      className: styles.toolbarDivider
    }), helpMeWriteButton]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(FullColumn, {
      gap: 8,
      alignItems: "start",
      children: [!hideLabel && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph2",
        skin: "secondary",
        testId: "".concat(testId, "-label"),
        children: isBundle ? 'Bundle description' : 'Service description'
      }), /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "description",
        rules: richTextValidation(),
        render: renderProps => {
          const connected = connectControllerToRichTextEditor(renderProps);
          const originalEditorRef = connected.editorRef;
          return /*#__PURE__*/_jsx(RichTextEditor, _objectSpread(_objectSpread({
            editorHeight: 310,
            placeholder: "Describe service (Optional)",
            testId: testId
          }, connected), {}, {
            editorRef: el => {
              editorElRef.current = el;
              if (typeof originalEditorRef === 'function') {
                originalEditorRef(el);
              }
            },
            onChange: v => {
              _onChange(v);
              connected.onChange(v);
            },
            toolbarActions: toolbarActions,
            disabled: disabled
          }));
        }
      })]
    }), variablesEnabled && /*#__PURE__*/_jsx(VariablePickerPopover, _objectSpread({}, pickerPopoverProps))]
  });
};
export default ServiceDescription;